import { TooltipTextRequest, VisualId } from '@tableau/api-internal-contract-js';

export class TooltipTextRequestModel implements TooltipTextRequest {
  public constructor(public visualIdPresModel: VisualId, public tupleId: number) {}
}
